export default __webpack_public_path__ + "static/media/payPlusQRCode.75049126.png";